export default "__VITE_ASSET__e2c1875d__"